import { BaseError } from '@/util/base-error'

export class SignupError extends BaseError {
  constructor(
    message: string,
    readonly label: string
  ) {
    super(message)
  }
}
